import gql from 'graphql-tag';

export const markUserInactive = gql`
  mutation markUserInactive($id: String!) {
    markUserInactive(id: $id)
  }
`;
